export const OrderBillingInformationFormConstants = {
    SUCCESS_ALERT_MESSAGE:
        'Order billing information has been successfully saved.',
} as const;
